import { Component, inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogTitle, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import { CompanyProductPhase } from 'src/app/models/company_product_phase.model';
import { CompanyProductPhaseStage } from 'src/app/models/company_product_phase_stage.model';
import { CompanyProductPhaseType } from 'src/app/models/company_product_phase_type.model';
import { CompanyProductTeam } from 'src/app/models/company_product_team.model';
import { ApiService } from 'src/app/services/api.service';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatLabel, MatFormField } from '@angular/material/form-field';
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/autocomplete';
import { MatCheckbox } from '@angular/material/checkbox';
import { MatButton } from '@angular/material/button';
import { ProductTaskTypeImagePipe } from 'src/app/pipes/product-task-type-image.pipe';
import { ArrayResponse } from 'src/app/models/array_response.interface';

interface CompanyProductPhaseEditDialogData {
  company_product_phase: CompanyProductPhase;
}

@Component({
  selector: 'app-company-product-phase-edit-dialog',
  templateUrl: './company-product-phase-edit-dialog.component.html',
  styleUrls: ['./company-product-phase-edit-dialog.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    MatDialogTitle,
    CdkScrollable,
    MatDialogContent,
    FormsModule,
    ReactiveFormsModule,
    MatLabel,
    MatFormField,
    MatSelect,
    MatOption,
    MatCheckbox,
    MatDialogActions,
    MatButton,
    ProductTaskTypeImagePipe,
  ],
})
export class CompanyProductPhaseEditDialogComponent implements OnInit {
  private readonly api = inject(ApiService);
  private readonly data = inject<CompanyProductPhaseEditDialogData>(MAT_DIALOG_DATA);
  private readonly dialogRef = inject(MatDialogRef<CompanyProductPhaseEditDialogComponent>);
  private readonly fb = inject(UntypedFormBuilder);

  form: UntypedFormGroup;
  company_product_phase: CompanyProductPhase = this.data.company_product_phase;
  company_product_phase_stages: CompanyProductPhaseStage[] = [];
  company_product_phase_types: CompanyProductPhaseType[] = [];
  company_product_teams: CompanyProductTeam[] = [];

  ngOnInit(): void {
    this.form = this.fb.group({
      company_product_phase_type_id: [this.company_product_phase.company_product_phase_type_id, [Validators.required]],
      company_product_id: [this.company_product_phase.company_product_id, []],
      company_product_phase_stage_id: [this.company_product_phase.company_product_phase_stage_id, []],
      contract_id: [this.company_product_phase.contract_id, []],
      company_product_team_id: [this.company_product_phase.company_product_team_id ?? null, []],
      needs_hours_story: [this.company_product_phase.needs_hours_story, []],
      needs_hours_task: [this.company_product_phase.needs_hours_task, []],
      needs_hours_issue: [this.company_product_phase.needs_hours_issue, []],
      enable_roadmap: [this.company_product_phase.enable_roadmap, []],
    });
    this.fetchCompanyProductPhaseStages();
    this.fetchCompanyProductPhaseTypes();
    this.fetchCompanyProductTeams();
  }

  fetchCompanyProductPhaseStages() {
    this.api.getCompanyProductPhaseStages().subscribe(data => {
      this.company_product_phase_stages = data;
    });
  }

  fetchCompanyProductPhaseTypes(): void {
    this.api.getCompanyProductPhaseTypes().subscribe((data: ArrayResponse<CompanyProductPhaseType>): void => {
      this.company_product_phase_types = data.data;
    });
  }

  fetchCompanyProductTeams() {
    this.api.getCompanyProductCompanyProductTeams(this.company_product_phase.company_product_id.toString()).subscribe(data => {
      this.company_product_teams = data;
    });
  }

  save() {
    this.dialogRef.close(this.form.value);
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  onCancel() {
    this.dialogRef.close();
  }
}
